import { render } from "./StatusSendFormModal.vue?vue&type=template&id=565b24bb"
import script from "./StatusSendFormModal.vue?vue&type=script&lang=js"
export * from "./StatusSendFormModal.vue?vue&type=script&lang=js"

import "./StatusSendFormModal.vue?vue&type=style&index=0&id=565b24bb&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__